module.exports = __webpack_public_path__ + "static/img/pic21.27754d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic21.png
// module id = Rmjr
// module chunks = 0